import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { CAST_USER_CONSTANTS } from './../cast-user.constants';
import { CastMemberData } from './../../interfaces/cast-user.interface';
import { CheckOfferElibilityResponse } from './../../interfaces/check-offer-eligibility-response.interface';

@Injectable()
export class CastUserRestService {
    private baseUrl: string;

    constructor(
        private httpClient: HttpClient
    ) {}

    /**
     * Set base URL from the Spa that uses this service
     * It is mandatory to configure this url in the appModule
     * @param url base url to be set
     */
    setBaseUrl(url: string) {
        this.baseUrl = url;
    }

    /**
     * Call endpoint to get cast data using baseUrl
     * @returns {Observable<CastMemberData>}
     */
    getCastData(): Observable<CastMemberData> {
        return this.httpClient.get<CastMemberData>(`${this.baseUrl}${CAST_USER_CONSTANTS.ENDPOINTS.CAST_INFO}`);
    }

    /**
     * Call endpoint to check offer eligibility using baseUrl
     * @param offerId offer to be checked
     * @returns {Observable<CheckOfferElibilityResponse>}
     */
    checkOfferEligibility(offerId: string): Observable<CheckOfferElibilityResponse> {
        const regionId = CAST_USER_CONSTANTS.SPECIAL_OFFERS.INTL_REGION + CAST_USER_CONSTANTS.SPECIAL_OFFERS.US_REGION;
        const path = CAST_USER_CONSTANTS.ENDPOINTS.CHECK_OFFER_ELIGIBILITY
            .replace('{offerId}', encodeURIComponent(offerId))
            .replace('{regionId}', regionId);

        return this.httpClient.get<CheckOfferElibilityResponse>(`${this.baseUrl}${path}`);
    }
}
